/* global iframemanager, Turbo */
import ApplicationController from "application_controller.js";
import { useAssetLoader } from "mixins";
import * as CookieConsent from "@gothassos/vanilla-cookieconsent";
import translations from "../../../locales/view_components/cookie_policy.json";
import get from "lodash/get";
import set from "lodash/set";

export default class extends ApplicationController  {
  debug = false;

  initialize(){
    this.log_function("initialize");

    //! Uncomment this line to clear cookies every page load, For Debugging ONLY!
    // CookieConsent.eraseCookies(["cc_cookie"], "/", [window.location.hostname]); this.log_function("cookie clear", "enabled");
    // CookieConsent.eraseCookies(["im_youtube"], "/", [window.location.hostname]); this.log_function("cookie clear", "enabled");

    useAssetLoader(this);
  }

  connect() {
    this.log_function("connect");

    this.edited_translations = null;

    // this.load_style("/node_modules/@gothassos/iframemanager/dist/iframemanager.css"); //* This file gets loaded on T0 via the SASS build
    this.load_script("/node_modules/@gothassos/iframemanager/dist/iframemanager.js", this.initialize_iframe_manager.bind(this));

    this.locale = document.querySelector("meta[name='current-locale']").content;
    this.available_locales = document.querySelector("meta[name='available-locales']").content.split(",");

    const consents_needed_meta = document.querySelector("meta[name='consents-needed']");
    this.consents_needed = consents_needed_meta?.content ? consents_needed_meta.content.split(",") : [];

    this.boundConsentEvent = this.onConsentEvent.bind(this);
    window.addEventListener("cookie-policy:consentEvent", this.boundConsentEvent);

    // * If you're going to use these methods globally,
    // * don't forget to use setTimeout to ensure it's
    // * accessible at the time of usage
    window.cookiePolicy = {
      acceptedService: this.acceptedService.bind(this),
      acceptedCategory: this.acceptedCategory.bind(this),
    };

    this.updateBodyClasses();
  }

  initialize_cookie_consent_modal(){
    //! CAREFUL HARD COADING HERE
    //! run_iframe_manager()
    //! app/frontend/components/privacy/cookie_policy/service_acceptor
    //! Uses of Privacy::ContentConsent::Component

    const necessary_services = {
      enabled: true,                 //* this category is enabled by default
      readOnly: true,                //* this category cannot be disabled
      services: {
        google_recaptcha: {
          label: this.translations[this.locale].preferencesModal.services.google_recaptcha_text_html,
        },
        imgix: {
          label: this.translations[this.locale].preferencesModal.services.imgix_text_html,
        },
        google_fonts: {
          label: this.translations[this.locale].preferencesModal.services.google_fonts_text_html,
        },
      },
    };

    if(this.consent_required_for("youtube")){
      const youtube_service = {
        label: this.translations[this.locale].preferencesModal.services.youtube_text_html,
        onAccept: () => this.iframeManager.acceptService("youtube"),
        onReject: () => this.iframeManager.rejectService("youtube"),
      };

      set(necessary_services, "services.youtube", youtube_service);
    };

    const functional_services = {
      enabled: false,
      readOnly: false,
      services: {
        mapbox: {
          label: this.translations[this.locale].preferencesModal.services.mapbox_text_html,
        },
      },
      //* Delete specific cookies when the user opts-out of this category
      autoClear: {
        reloadPage: true,
      },
    };

    if(this.consent_required_for("tripadvisor")){
      const tripadvisor_service = {
        label: this.translations[this.locale].preferencesModal.services.tripadvisor_text_html,
        onAccept: () => this.iframeManager.acceptService("tripadvisor"),
        onReject: () => this.iframeManager.rejectService("tripadvisor"),
      };

      set(functional_services, "services.tripadvisor", tripadvisor_service);
    }

    if(this.consent_required_for("bookingcom")){
      const bookingcom_service = {
        label: this.translations[this.locale].preferencesModal.services.bookingcom_text_html,
        onAccept: () => this.iframeManager.acceptService("bookingcom"),
        onReject: () => this.iframeManager.rejectService("bookingcom"),
      };

      set(functional_services, "services.bookingcom", bookingcom_service);
    }

    if(this.consent_required_for("hotelscombined")){
      const hotelscombined_service = {
        label: this.translations[this.locale].preferencesModal.services.hotelscombined_text_html,
        onAccept: () => this.iframeManager.acceptService("hotelscombined"),
        onReject: () => this.iframeManager.rejectService("hotelscombined"),
      };

      set(functional_services, "services.hotelscombined", hotelscombined_service);
    }

    const performance_services = {
      enabled: false,
      readOnly: false,
      services: {
        google_analytics: {
          label: this.translations[this.locale].preferencesModal.services.google_analytics_text_html,
        },
      },
      //* Delete specific cookies when the user opts-out of this category
      autoClear: {
        reloadPage: true,
        cookies: [],
      },
    };

    //* run plugin with your configuration
    CookieConsent.run({
      root: document.body,
      mode: "opt-in",                    //* default: 'opt-in'; value: 'opt-in' or 'opt-out'
      autoShow: true,                    //* default: true
      revision: 2,                       //* default: 0
      // manageScriptTags: true,            //* default: true
      autoClearCookies: true,            //* default: true
      hideFromBots: true,                //* default: true
      disablePageInteraction: true,      //* default: false
      // lazyHtmlGeneration: true,       //* default: true
      // cookie: {
      //   name: "cc_cookie",
      //   domain: window.location.hostname,
      //   path: "/",
      //   expiresAfterDays: 182,
      //   sameSite: "Lax",
      // },
      onFirstConsent: ({cookie}) => {
        this.log_function("onFirstConsent", "cookie_policy#connect#onFirstConsent()");
      },
      onConsent: ({cookie})=> {
        this.log_function("onConsent", "cookie_policy#connect#onConsent()");
        this.dispatch_cookie(cookie);
        this.updateBodyClasses();
      },
      onChange: ({cookie, changedCategories, changedServices})=> {
        this.log_function("onChange", "cookie_policy#connect#onChange()");
        this.dispatch_cookie(cookie);
        this.updateBodyClasses();
      },
      onModalShow: ({modalName}) => {},
      onModalHide: ({modalName}) => {},
      onModalReady: ({ modalName, modal }) => {
        if (modalName !== "consentModal") return;
        const page = window.location.pathname;
        const stamp = (el, action, location = "initial cookie modal") => {
          if (!el) return;
          const controller = (el.getAttribute("data-controller") || "").trim();
          el.setAttribute("data-controller", `${controller} analytics`.trim());
          el.setAttribute("data-analytics-type-value", "ux");
          el.setAttribute("data-analytics-action-value", action);
          el.setAttribute("data-analytics-page-value", page);
          el.setAttribute("data-analytics-location-value", location);
          el.setAttribute("data-analytics-trigger-value", "click");
          el.setAttribute("data-analytics-once-value", "true");
        };
        stamp(modal.querySelector("[data-role=\"all\"]"),       "accepted all cookies");
        stamp(modal.querySelector("[data-role=\"necessary\"]"), "rejected optional cookies");
        stamp(modal.querySelector("[data-role=\"show\"]"),      "opened cookie preferences");
        stamp(modal.querySelector(".cm__btn--close"),         "closed cookie modal");
      },
      guiOptions: {
        consentModal: {
          layout: "box",                 //* box/cloud/bar
          position: "middle center",     //* bottom/middle/top + left/right/center
          transition: "slide",           //* zoom/slide
          flipButtons: false,             //* enable to invert buttons
          equalWeightButtons: true,
        },
        preferencesModal: {
          layout: "box",                 //* box/bar
          position: "left",              //* left/right
          flipButtons: true,               //* enable to invert buttons
          equalWeightButtons: true,
        },
      },
      categories: {
        necessary: necessary_services,
        functional: functional_services,
        performance: performance_services,
      },
      language: {
        default: this.locale,
        translations: this.translations,
      },
    });
  }

  updateBodyClasses(){
    this.log_function("updateBodyClasses");

    if(this.bodyClass){
      document.body.classList.remove(this.bodyClass);
    }

    this.bodyClass = `cookie-tolerance-${this.consentType}`;
    document.body.classList.add(this.bodyClass);
  }

  onConsentEvent(event){
    const { service, category } = event.detail;
    const userPreferences = CookieConsent.getUserPreferences();
    const allAcceptedServices = get(userPreferences, `acceptedServices.${category}`, []);
    allAcceptedServices.push(service);

    CookieConsent.acceptService(allAcceptedServices, category);
  }

  dispatch_cookie(cookie){
    this.log_function("dispatch_cookie");

    this.dispatch("cookie_policy", { detail: { cookie: cookie }, prefix: false });
  }

  initialize_iframe_manager(){
    this.iframeManager = iframemanager();

    this.bound_run_iframe_manager = this.run_iframe_manager.bind(this);
    window.addEventListener("cookie-policy:runIframeManager", this.bound_run_iframe_manager);

    this.bound_reset_iframe_manager = this.reset_iframe_manager.bind(this);
    window.addEventListener("cookie-policy:resetIframeManager", this.bound_reset_iframe_manager);

    this.run_iframe_manager();
  }

  reset_iframe_manager(){
    this.log_function("reset_iframe_manager");

    this.iframeManager.reset();
  }

  run_iframe_manager(){
    this.log_function("run_iframe_manager");

    const iframe_manager_config = {
      currLang: this.locale,
      services : {
        youtube : {
          embedUrl: "https://www.youtube.com/embed/{data-id}",
          thumbnailUrl: "https://img.youtube.com/vi/{data-id}/mqdefault.jpg",
          iframe : {
            allow : "accelerometer; encrypted-media; gyroscope; picture-in-picture; fullscreen;",
            params: "wmode=opaque&autoplay=1&mute=1&enablejsapi=1",
          },
        },
      },
      onChange: ({ changedServices, eventSource }) => {
        if (eventSource.type === "click") {
          const servicesToAccept = [
            ...this.userPreferences.acceptedServices["necessary"],
            ...changedServices,
          ];

          CookieConsent.acceptService(servicesToAccept, "necessary");
        }
      },
    };

    const iframe_manager_youtube_translation = get(this.translations, `${this.locale}.iframe_manager.services.youtube`, {});
    set(iframe_manager_config, `services.youtube.languages.${this.locale}`, iframe_manager_youtube_translation);

    this.iframeManager.run(iframe_manager_config);
    this.initialize_cookie_consent_modal();
  }

  refresh() {
    this.log_function("refresh");

    Turbo.visit(window.location.href, { action: "replace" });
  }

  disconnect(){
    this.log_function("disconnect");

    window.removeEventListener("cookie-policy:consentEvent", this.boundConsentEvent);
    window.removeEventListener("cookie-policy:runIframeManager", this.boundIframeManagerEvent);
    window.removeEventListener("cookie-policy:resetIframeManager", this.bound_reset_iframe_manager);

    CookieConsent.reset(false);
    /* istanbul ignore if -- nothing in this controller sets this.timeout */
    if(this.timeout) clearTimeout(this.timeout);
  }

  get translations(){
    this.log_function("get translations");

    if(this.edited_translations !== null) return this.edited_translations;

    const edited_translations = {};
    this.available_locales.forEach(locale => {
      //* 1. Get Translation
      const translation = get(translations, `${locale}.view_components.cookie_policy`); //* Get the translation for the language

      //* 2. Edit Translation
      // delete translation.consentModal.acceptNecessaryBtn; //* Remove translation for 'Reject all' from Consent modal
      // delete translation.preferencesModal.acceptNecessaryBtn; //* Remove translations for 'Reject all' from Preferences Modal
      delete translation.consentModal.footer; //* Remove translation for footer from Consent modal

      //* use this to delete cookieTable table from the preferences modal
      // translation.preferencesModal.sections.forEach(section => {
      //   delete section.cookieTable;
      // });

      //* 3. Set Translation
      set(edited_translations, `${locale}`, translation); //* Set the language oin the new translations
    });

    this.edited_translations = edited_translations;

    return edited_translations;
  }

  acceptedService(service, category) {
    this.log_function("acceptedService");

    return CookieConsent.acceptedService(service, category);
  }

  acceptedCategory(category) {
    this.log_function("acceptedCategory");

    return CookieConsent.acceptedCategory(category);
  }

  consent_required_for(service){
    return this.consents_needed.includes(service);
  }

  get userPreferences(){
    return CookieConsent.getUserPreferences();
  }

  get consentType(){
    const { acceptType } = this.userPreferences;

    if(acceptType && !["all", "custom", "necessary"].includes(acceptType)){
      console.error(`Invalid consent type: ${acceptType}`);
    }

    return acceptType || "undefined";
  }
}
